import { render, staticRenderFns } from "./NewListingComponent.vue?vue&type=template&id=8b4c2cf2&scoped=true&"
import script from "./NewListingComponent.vue?vue&type=script&lang=js&"
export * from "./NewListingComponent.vue?vue&type=script&lang=js&"
import style0 from "./NewListingComponent.vue?vue&type=style&index=0&id=8b4c2cf2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4c2cf2",
  null
  
)

export default component.exports